import React, { useState } from "react";
import { Col, Row, Table } from "reactstrap";
import style from "./styles.module.scss";

const GridPeopleInfo = ({ reportBCU, deletePerson }) => {
  return (
    <div className={style.grid}>
      <div className={style.header}>People Selected</div>
      <Table responsive hover>
        <thead>
          <tr>
            <th>Type</th>
            <th>Name</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {reportBCU &&
            reportBCU.map((person) => {
              return (
                <tr>
                  <td>{person.personType}</td>
                  <td>{person.personName}</td>
                  <td onClick={() => deletePerson(person.personId)}>
                    <i className="fa fa-times"></i>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
    </div>
  );
};
export default GridPeopleInfo;
